import { forwardRef, useCallback, useEffect, useState } from 'react'
import { SVGs } from '../..'
import useDelayUnmount from '../../Hooks/useDelayUnmount'
import useTimeout from '../../Hooks/useTimeout'
import SVG from '../SVG'
import { SnackbarProps } from './props'
import { StyledCloseIcon, StyledSnackbar } from './styles'

const Snackbar = forwardRef<HTMLDivElement, SnackbarProps>(
    (
        {
            action = 'success',
            autoHideDuration = 5000,
            children,
            isOpen = false,
            onClose = () => undefined,
            ...props
        },
        ref
    ) => {
        const [isLocalOpen, setIsLocalOpen] = useState(isOpen)

        useEffect(() => {
            setIsLocalOpen(isOpen)
        }, [isOpen])

        const hide = useCallback(() => setIsLocalOpen(false), [])

        useTimeout(hide, autoHideDuration)

        const shouldRender = useDelayUnmount(isLocalOpen, 300)

        return shouldRender ? (
            <StyledSnackbar
                {...props}
                action={action}
                isOpen={isLocalOpen}
                ref={ref}
            >
                {children}
                <StyledCloseIcon
                    onClick={() => {
                        onClose()
                        hide()
                    }}
                >
                    <SVG src={SVGs.Close} />
                </StyledCloseIcon>
            </StyledSnackbar>
        ) : (
            <></>
        )
    }
)

Snackbar.displayName = 'Snackbar'

export default Snackbar

export { StyledSnackbar }
